// extracted by mini-css-extract-plugin
module.exports = {"container":"Skeleton_container__2TAdw","circle":"Skeleton_circle__xPlLl","load-skeleton":"Skeleton_load-skeleton__3ybhf"};